<template>
  <div class="smart_intercept">
    <tip-switch
      :title="switchTipTit"
      :content="openeTipTxt"
      :value="switchConfig"
      :disabled="isSeting"
      @change="toOpenSwitch"
    />
    <div class="intercept_main">
      <field-item :field="normalCTit">
        <a-checkbox
          :checked="includeUrl"
          @change="switchUrl"
        >
          {{ $t('message["1252"]') }}
        </a-checkbox>
        <a-checkbox
          :checked="!!baseConfig.irrigation"
          :disabled="true"
          @change="switchIrr"
        >
          {{ $t('message["1285"]') }}
        </a-checkbox>
      </field-item>
      <field-item :field="defineConTit">
        <div class="input_work">
          <a-textarea
            v-model="interceptContent"
            :placeholder="definePlacheholder"
          />
        </div>
      </field-item>
      <field-item>
        <a-button
          class="save"
          type="primary"
          @click="toSave"
        >
          {{ $t('message["21"]') }}
        </a-button>
      </field-item>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import tipSwitch from './components/TipTool'
import fieldItem from './components/FieldMain'
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  components: {
    tipSwitch,
    fieldItem
  },
  data () {
    return {
      // irrigation: 1
    }
  },
  computed: {
    ...mapState('config/smart', ['baseConfig', 'isSeting']),
    switchConfig () {
      return this.baseConfig.is_intercept === 1
    },
    interceptContent: {
      get () {
        return this.baseConfig.interceptContent
      },
      set (value) {
        this.SET_BASE_CONFIG_KEY({ key: 'interceptContent', value })
      }
    },
    includeUrl: {
      get () {
        return this.baseConfig.is_include_url === 1
      },
      set (value) {
        this.SET_BASE_CONFIG_KEY({ key: 'is_include_url', value })
      }
    },
    normalCTit () {
      return this.$t('message["98"]')
    },
    definePlacheholder () {
      return this.$t('message["262"]')
    },
    openeTipTxt () {
      return this.$t('message["557"]')
    },
    switchTipTit () {
      return this.$t('message["1087"]')
    },
    defineConTit () {
      return this.$t('message["1662"]')
    }
  },
  ceated () {
    // this.baseConfig.irrigation = 1
  },
  methods: {
    ...mapActions('config/smart', ['setFormConfig']),
    ...mapMutations('config/smart', ['SET_BASE_CONFIG_KEY']),
    async toOpenSwitch (value) {
      await this.setFormConfig({ is_intercept: value ? 1 : 0 })
    },
    async toSave () {
      // 过滤掉数组中为空的内容
      let aWords = this.interceptContent.split('\n').filter(item => item !== '')
      let includeUrl = this.includeUrl ? 1 : 0
      await this.setFormConfig({ intercept_dict: aWords, is_include_url: includeUrl, irrigation: this.baseConfig.irrigation })
    },
    switchUrl (e) {
      const { checked } = e.target
      this.includeUrl = checked ? 1 : 0
    },
    switchIrr (e) {
      const { checked } = e.target
      this.baseConfig.irrigation = checked ? 1 : 0
    }
  }
}
</script>

<style scoped lang="scss">
.smart_intercept {
  margin: 24px 0;
  .intercept_main {
    margin: 24px 0;
    .input_work {
      width: 320px;
      height: 200px;
      border-radius: 4px;
      border: 1px solid #d6d6d6;
      textarea {
        border: none;
        resize: none;
        height: 100%;
      }
    }
    ::v-deep .ant-checkbox-wrapper {
      margin-top: 9px;
    }
  }
}
</style>
